import { render, staticRenderFns } from "./ClerkNewPartsReq.vue?vue&type=template&id=e21c98c4&scoped=true&"
import script from "./ClerkNewPartsReq.vue?vue&type=script&lang=js&"
export * from "./ClerkNewPartsReq.vue?vue&type=script&lang=js&"
import style0 from "./ClerkNewPartsReq.vue?vue&type=style&index=0&id=e21c98c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21c98c4",
  null
  
)

export default component.exports